import axios from "axios";
import {
  deleteFromLocalStorage,
  getFromLocalStorage,
} from "../helpers/localstorage";
import { message } from "antd";
import { RiCloseCircleLine } from "react-icons/ri";

const API_URL = process.env.REACT_APP_API_URL;

const client = axios.create({
  baseURL: API_URL,
});

client.interceptors.request.use(
  (config) => {
    if (config?.headers && localStorage.getItem('token'))
      config.headers.Authorization = `Bearer ${getFromLocalStorage("token")}`;
    return config;
  },
  (error) => Promise.reject(error)
);

client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      message.error({
        content: (Array.isArray(error.response.data?.message)
          ? error.response.data?.message?.[0]
          : error.response.data?.message) || "An error occurred",
        icon: <RiCloseCircleLine className="remix-icon" />,
        duration: 3,
        type: "error",
      });
    }
    if (error.response && (error.response.status === 401 ||  error.response.status === 403)) {
      deleteFromLocalStorage("token");

      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default client;
